import { Stack, Button, type StackProps } from '@mui/material';
import { useI18n } from '../../../i18n/I18nProvider';
import { translateUiText } from '../../../i18n/translateUiText';
import { isDemoDashboardWriteProtected, notifyDemoWriteBlocked } from '../../../utils/demoMode';

interface Props extends StackProps {
  onCancel?: () => void;
  onSubmit?: () => void;
  cancelLabel?: string;
  submitLabel?: string;
  loading?: boolean;
  disableSubmit?: boolean;
  submitColor?: 'primary' | 'success' | 'error' | 'warning';
}

export default function FormActions({
  onCancel,
  onSubmit,
  cancelLabel = 'Cancel',
  submitLabel = 'Save',
  loading = false,
  disableSubmit = false,
  submitColor = 'primary',
  ...stackProps
}: Props) {
  const { t } = useI18n();

  return (
    <Stack direction="row" spacing={1.25} justifyContent="flex-end" {...stackProps}>
      {onCancel && (
        <Button variant="outlined" color="inherit" onClick={onCancel} disabled={loading} sx={{ minWidth: 96 }}>
          {translateUiText(cancelLabel, t)}
        </Button>
      )}
      {onSubmit && (
        <Button
          variant="contained"
          color={submitColor}
          onClick={() => {
            if (isDemoDashboardWriteProtected()) {
              notifyDemoWriteBlocked();
              return;
            }
            onSubmit();
          }}
          disabled={disableSubmit || loading}
          sx={{ minWidth: 112, fontWeight: 600 }}
        >
          {translateUiText(submitLabel, t)}
        </Button>
      )}
    </Stack>
  );
}
